import { Button as MaterialButton } from '@mui/material'

const Button = MaterialButton

export { Button }
